import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';
import { WKZRechner } from '../../../../components/WKZRechner.jsx';

export function WkzRechnerRender({ node, isLiveMode }) {
  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto', width: '100%', maxWidth: '800px', margin: '0 auto' }}>
      <WKZRechner />
    </div>
  );
}

registry.register('WKZRechner', {
  label: 'WKZ Rechner',
  icon: '💰', 
  category: 'tef',
  component: WkzRechnerRender,
  
  defaultProps: {
    content: {},
    style: {
      desktop: {
        padding: '20px 0'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Hinweise',
          fields: [
            { name: 'content.info', label: 'Dieser Rechner ist vollautark und benötigt aktuell keine weiteren Parameter.', type: 'text', readOnly: true }
          ]
        }
      ]
    }
  ]
});
